import React, { useCallback } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Flex, Text } from "@jsq/ds/core";
import { PayeesTable } from "@jsq/payments-components";
import { globalEnv } from "~/global-env";
import CreatePayeeDropdown from "./CreatePayeeDropdown";
import { payeesHeader, payeesTableContainer } from "./styles_vanilla.css";

type PayeesPageParams = {
  payeeId?: string;
};

const PayeesPage: React.FC = () => {
  const { payeeId } = useParams<PayeesPageParams>();
  const history = useHistory();

  const handleSelectPayee = useCallback(
    (selectedPayeeId: string) => {
      history.push(`${globalEnv.treasuryRoute}/payees/${selectedPayeeId}`);
    },
    [history],
  );

  const handleSlideoutClose = useCallback(() => {
    history.push(`${globalEnv.treasuryRoute}/payees`);
  }, [history]);

  return (
    <Flex className={payeesTableContainer}>
      <Flex className={payeesHeader}>
        <Text variant="h2">Payees</Text>
        <CreatePayeeDropdown />
      </Flex>
      <PayeesTable
        selectedPayeeId={payeeId}
        onSelectPayee={handleSelectPayee}
        onCloseSlideout={handleSlideoutClose}
      />
    </Flex>
  );
};

export default PayeesPage;
